import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ESTADOS_EMPRESA, ROLES } from "../../lib/format";
import { PageHeader } from "../../components/PageHeader";

const Card = ({ label, value, testId }) => (
  <div className="bg-white border border-slate-200 rounded-xl p-6">
    <p className="text-xs uppercase tracking-wider text-slate-500">{label}</p>
    <p className="font-heading text-3xl font-bold text-slate-900 mt-2" data-testid={testId}>{value ?? 0}</p>
  </div>
);

export default function Metricas() {
  const [m, setM] = useState(null);
  useEffect(() => {
    api.get("/admin/metrics").then((r) => setM(r.data));
  }, []);
  if (!m) return null;
  return (
    <div className="space-y-8">
      <PageHeader overline="Superadmin" title="Métricas de uso" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card label="Empresas" value={m.empresas_total} testId="metric-empresas" />
        <Card label="Registros últimos 30 días" value={m.registros_30_dias} testId="metric-registros" />
        <Card label="Ingresos últimos 7 días" value={m.logins_7_dias} testId="metric-logins" />
        <Card label="Ingresos fallidos 7 días" value={m.logins_fallidos_7_dias} testId="metric-logins-fallidos" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-2">
          <h2 className="font-heading font-semibold">Empresas por estado</h2>
          {Object.keys(ESTADOS_EMPRESA).map((k) => <p key={k} className="flex justify-between text-sm"><span>{ESTADOS_EMPRESA[k]}</span><b>{m.empresas_por_estado[k] || 0}</b></p>)}
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-2">
          <h2 className="font-heading font-semibold">Usuarios por rol</h2>
          {["owner", "compliance_officer", "operator"].map((k) => <p key={k} className="flex justify-between text-sm"><span>{ROLES[k]}</span><b>{m.usuarios_por_rol[k] || 0}</b></p>)}
        </div>
      </div>
    </div>
  );
}
